<template>
  <div>
    <div class="page-title">Edit Redirect</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Redirect"
      @destroy="destroy"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.redirects.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject ? `Edit “${subject}”` : `Edit Redirect`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async update() {
      await this.$api.Page.update(this.form);
      this.$router.push("/redirects");
    },
    async setForm() {
      const { data } = await this.$api.Page.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async destroy() {
      const confirmed = await this.$confirmWindow({
        title: "Are you sure?",
      });
      if (!confirmed) return;

      await this.$api.Page.destroy({ id: this.form.id });
      this.$router.push("/redirects");
    },
  },
};
</script>

<style></style>
